var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApartmentsAlt8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 11.2308C2 6.13276 6.13276 2 11.2308 2C11.6556 2 12 2.3444 12 2.76923V9L20.5747 11.5724C21.4207 11.8262 22 12.6048 22 13.4881V21.25C22.4142 21.25 22.75 21.5858 22.75 22C22.75 22.4142 22.4142 22.75 22 22.75H2C1.58579 22.75 1.25 22.4142 1.25 22C1.25 21.5858 1.58579 21.25 2 21.25V11.2308ZM4.75 10C4.75 10.4142 5.08579 10.75 5.5 10.75H8.5C8.91421 10.75 9.25 10.4142 9.25 10C9.25 9.58579 8.91421 9.25 8.5 9.25H5.5C5.08579 9.25 4.75 9.58579 4.75 10ZM4.75 14C4.75 14.4142 5.08579 14.75 5.5 14.75H8.5C8.91421 14.75 9.25 14.4142 9.25 14C9.25 13.5858 8.91421 13.25 8.5 13.25H5.5C5.08579 13.25 4.75 13.5858 4.75 14ZM4.75 18C4.75 18.4142 5.08579 18.75 5.5 18.75H8.5C8.91421 18.75 9.25 18.4142 9.25 18C9.25 17.5858 8.91421 17.25 8.5 17.25H5.5C5.08579 17.25 4.75 17.5858 4.75 18ZM19 17C19 15.8954 18.1046 15 17 15C15.8954 15 15 15.8954 15 17V21.25H19V17Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApartmentsAlt8);
export default __webpack_public_path__ + "static/media/apartments-alt-8.c1e4232d61560c6b1516682953dfcfdb.svg";
export { ForwardRef as ReactComponent };